<template>
  <div>
    <h2>Old search</h2>
    <p>
      Use the widget below to search the system old style. Or use the links in
      the menu to the left to select by entity type. Then use a table to search
      the entire address book.
    </p>
    <v-select
      v-model="typeid"
      label="Entity type"
      :items="types"
      item-value="id"
      item-text="name"
      @change="changedType"
      outline
    />
    <v-text-field
      :label="filterName"
      v-model="filter"
      outline
      v-if="filterName"
    />
    <v-btn v-if="filterName" @click="changedType">
      <v-icon>search</v-icon>&#160;Search
    </v-btn>
    <div style="margin: 5px" v-if="existingResults && existingResults.length">
      <ul>
        <template v-for="(searchObject, index) in existingResults">
          <li :key="`group${index}`" v-if="searchObject.existingGroup">
            <router-link
              :to="{
                name: 'group',
                params: { id: searchObject.existingGroup.groupId },
              }"
            >
              <strong>{{ searchObject.existingGroup.body }}</strong>
            </router-link>
          </li>
          <li :key="index">
            <Entity :entity="searchObject.entity" />
            <span style="color: gray">
              <span v-if="searchObject.entity.extra">{{
                searchObject.entity.extra
              }}</span>
              <span v-if="searchObject.dob">{{ searchObject.dob }}</span>
            </span>
          </li>
        </template>
      </ul>
    </div>
    <v-dialog v-model="loadingSearch" persistent width="300">
      <v-card color="info" dark>
        <v-card-text>
          <span>Waiting for server to load search results...</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Entity from "@/components/link/Entity";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Existing",
  metaInfo() {
    return {
      title: "Old search",
      titleTemplate: "%s - Search - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  components: { Entity },
  data() {
    return {
      types: null,
      typeid: 4,
      existingResults: null,
      filter: null,
      filterName: null,
      loadingSearch: false,
    };
  },
  methods: {
    async fetchTypes() {
      const response = await nbmlaw.get(`/cors/admin/directory/types`);
      // console.log(response.data);
      this.types = response.data;
    },
    async fetchExistingResults() {
      this.loadingSearch = true;
      try {
        const response = await nbmlaw.get(
          `/cors/admin/directory/types/${this.typeid}/existingSearch`,
          {
            params: { filter: this.filter },
          }
        );
        // console.log(response.data);
        this.existingResults = response.data;
        this.loadingSearch = false;
      } catch (err) {
        this.loadingSearch = false;
      }
    },
    updateFilter() {
      if (this.typeid == 4) {
        this.filterName = "surname";
      } else if (this.typeid == 5) {
        this.filterName = "property";
      } else {
        this.filterName = null;
      }
    },
    changedType() {
      this.updateFilter();
      this.fetchExistingResults();
    },
  },
  created() {
    this.fetchTypes();
    this.changedType();
  },
};
</script>